// src/components/Website/WebsiteCard.js
import React from 'react';
import { Badge, Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const WebsiteCard = ({ website, onRemove }) => {
    const { id, url, name, status, lastCheckedAt, uptimePercentage = 95, securityScore = 80 } = website;

    const getStatusClass = () => {
        switch (status) {
            case 'online': return 'online';
            case 'issues': return 'issues';
            case 'offline': return 'offline';
            default: return '';
        }
    };

    const getStatusVariant = () => {
        switch (status) {
            case 'online': return 'success';
            case 'issues': return 'warning';
            case 'offline': return 'danger';
            default: return 'secondary';
        }
    };

    const getStatusText = () => {
        switch (status) {
            case 'online': return 'Online';
            case 'issues': return 'Problémy';
            case 'offline': return 'Offline';
            default: return 'Neznámý';
        }
    };

    const getStatusIcon = () => {
        switch (status) {
            case 'online': return 'fa-check-circle';
            case 'issues': return 'fa-exclamation-triangle';
            case 'offline': return 'fa-times-circle';
            default: return 'fa-question-circle';
        }
    };

    const getMetricColor = (value) => {
        if (value >= 90) return 'success';
        if (value >= 70) return 'warning';
        return 'danger';
    };

    return (
        <Card className={`website-card h-100 shadow-sm ${getStatusClass()}`}>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0 text-truncate">{name || url}</h5>
                <Badge bg={getStatusVariant()} className="ms-2 px-2 py-1">
                    <i className={`fas ${getStatusIcon()} me-1`}></i>
                    {getStatusText()}
                </Badge>
            </Card.Header>
            <Card.Body className="d-flex flex-column">
                <p className="text-muted small mb-3">
                    <i className="fas fa-link me-2"></i>
                    <a href={url.startsWith('http') ? url : `https://${url}`} target="_blank" rel="noopener noreferrer" className="text-reset text-truncate">
                        {url}
                    </a>
                </p>

                <Row className="mb-3">
                    <Col xs={6}>
                        <div className="d-flex align-items-center">
                            <div className="me-2">
                                <i className="fas fa-clock text-primary"></i>
                            </div>
                            <div>
                                <div className="small text-muted">Uptime</div>
                                <div className={`fw-bold text-${getMetricColor(uptimePercentage)}`}>
                                    {uptimePercentage}%
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6}>
                        <div className="d-flex align-items-center">
                            <div className="me-2">
                                <i className="fas fa-shield-alt text-primary"></i>
                            </div>
                            <div>
                                <div className="small text-muted">Bezpečnost</div>
                                <div className={`fw-bold text-${getMetricColor(securityScore)}`}>
                                    {securityScore}/100
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="text-muted mt-auto small mb-2">
                    <i className="fas fa-history me-1"></i>
                    Poslední kontrola: {new Date(lastCheckedAt).toLocaleString()}
                </div>
            </Card.Body>
            <Card.Footer className="d-flex justify-content-between align-items-center bg-light">
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => onRemove(id)}
                    title="Odstranit web"
                >
                    <i className="fas fa-trash"></i>
                </button>
                <Link to={`/websites/${id}`} className="btn btn-sm btn-primary">
                    <i className="fas fa-chart-line me-1"></i> Detaily
                </Link>
            </Card.Footer>
        </Card>
    );
};

export default WebsiteCard;